import { Location } from '../../models/location.model';
import { LocationsActions, LocationsActionTypes } from '../actions/locations.actions';

export interface LocationsState {
  items: Location[];
  selectedId: string | null;
  isLoading: boolean;
  error: string | null;
  total: number;
}

export const initialState: LocationsState = {
  items: [],
  selectedId: null,
  isLoading: false,
  error: null,
  total: 0
};

export function LocationsReducer(
  state = initialState,
  action: LocationsActions
): LocationsState {
  switch (action.type) {
    case LocationsActionTypes.LoadLocations:
      return { ...state, isLoading: true, error: null };

    case LocationsActionTypes.LoadLocationsSuccess:
      return {
        ...state,
        isLoading: false,
        error: null,
        items: action.payload.items,
        total: action.payload.total
      };

    case LocationsActionTypes.LoadLocationsFailure:
      return { ...state, isLoading: false, error: action.payload.error };

    case LocationsActionTypes.LoadLocation:
      return { ...state, isLoading: true, error: null };

    case LocationsActionTypes.LoadLocationSuccess:
      return {
        ...state,
        isLoading: false,
        error: null,
        selectedId: action.payload.location.id
      };

    case LocationsActionTypes.LoadLocationFailure:
      return { ...state, isLoading: false, error: action.payload.error };

    case LocationsActionTypes.CreateLocation:
      return { ...state, isLoading: true, error: null };

    case LocationsActionTypes.CreateLocationSuccess:
      return {
        ...state,
        isLoading: false,
        items: [...state.items, action.payload.location],
        total: state.total + 1
      };

    case LocationsActionTypes.CreateLocationFailure:
      return { ...state, isLoading: false, error: action.payload.error };

    case LocationsActionTypes.UpdateLocation:
      return { ...state, isLoading: true, error: null };

    case LocationsActionTypes.UpdateLocationSuccess:
      return {
        ...state,
        isLoading: false,
        items: state.items.map(item =>
          item.id === action.payload.location.id ? action.payload.location : item
        )
      };

    case LocationsActionTypes.UpdateLocationFailure:
      return { ...state, isLoading: false, error: action.payload.error };

    case LocationsActionTypes.SelectLocation:
      return { ...state, selectedId: action.payload.id };

    default:
      return state;
  }
}
